import {errorToast, successToast} from "../../Utils/utils";
import {ajaxRequest} from "../../Utils/Ajax/ajax";

function loadGoToAbListenerFunction(){
  const abCode = $("#ab-code").val();

  console.log("TEST");

  if (abCode == ""){
    errorToast("Bitte gib einen gültigen Code ein", "Fehler", 0);
    return;
  }

  // now test if it exists
  const success = function(data){
    // successToast('Tutor/-in wurde von deiner Instanz entfernt', 'Erfolg', 6500, true);
    window.location = "/ab/" + abCode
  }

  const onError = function(data){
    // Create the new paragraph element with the desired style and text
    var newParagraph = $('<p></p>')
      .addClass('temp-message') // Assign a unique class for easy selection
      .css('font-size', '1rem')
      .text('Ab konnte nicht gefunden werden');

    // Append the new paragraph to the end of the .modal-body div inside #go-to-ab
    $('#go-to-ab .modal-body').append(newParagraph);

    // Remove the paragraph after 10 seconds (10000 milliseconds)
    setTimeout(function(){
      newParagraph.remove();
    }, 10000);
  }

  ajaxRequest("/ab/" + abCode + "/check", success, {}, $(".load-ab-with-code"), true, onError);
}

export function loadGoToAbListener(){
    $(".load-ab-with-code").on("click", loadGoToAbListenerFunction);
    // $(".load-ab-with-code-permanent").on("click", loadGoToAbListenerFunction);
}
